<template lang="pug">
div.time-wrap
  .time-container
    .time-picker-wrap
      .time-picker-hd
        .time-picker-shortcuts
          span 选择时间范围：
          .btn.btn-default(href='javascript:;', @click.prevent="selectSpecificDay('all')") 全部时间
          .btn.btn-default(href='javascript:;', @click.prevent="selectSpecificDay('weekday')") 工作日
          .btn.btn-default(href='javascript:;', @click.prevent="selectSpecificDay('weekend')") 周末

      .time-picker-hint
        span.active
          i
          | 已投放时间
        span.origin
          i
          | 推荐投放时间
        span
          i
          | 暂停投放时间
      table.time-picker-bd
        thead
          tr
            th.time-picker-day
            th.time-picker-hour(v-for='hour in 24', :class='{active: isHourAllChecked[hour-1]}', @click='selectHour(hour-1)')
              i.fa.fa-arrow-down
        tbody
          tr(v-for='day in 7')
            td.time-picker-day
              label
                v-checkbox(v-model="isDayAllChecked[day-1]" @change.native="selectDay(day-1, $event.target.checked)") 
                | {{weekDay[day-1]}}
            td.time-picker-btns(v-for='hour in 24', :class="{'active': !!sgArr[day-1][hour-1],'origin': !sgArr[day-1][hour-1] && !!times[day-1][hour-1]}", @click='selectTime(day-1,hour-1)')
              span {{hour-1}}
      .time-picker-submit-wrap
        a.btn.btn-primary(href='javascript:;', @click.prevent='confirm') 确定
        a.btn.btn-default(href='javascript:;', @click.prevent='cancel') 取消
</template>

<script>
import Vue from 'vue'

String.prototype.repeat = String.prototype.repeat || function(n) { return Array(n+1).join(this) };
Array.prototype.fill = Array.prototype.fill || function(val) { for (var i = 0; i < this.length; i++) this[i] = val; return this;};

export default {
    props : {
        //默认选中的时间点，7*24的二维数组字符串，1表示选中，0表示未选中
        timearrstring: {
            //默认值为全部选中，即7*24个1
          default: ('1'.repeat(24)+',').repeat(7).slice(0,-1)
        }
    },
    data () {
        return {
            times: [],      //timestring初始化之后的数组
            weekDay : ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'],       //星期
            timeType: "all",
            timeOptions: [{
              value: "all",
              title: "全部时间"
            },{
              value: "weekday",
              title: "工作日"
            },{
              value: "weekend",
              title: "周末"
            }],
            initState: false                      //是否是初始状态
        }
    },
    computed : {
        //默认选中的时间点，7*24的二维数组字符串，1表示选中，0表示未选中
        timestring() {
            //默认值为全部选中，即7*24个1
            const defaultString = ('1'.repeat(24)+',').repeat(7).slice(0,-1)
            if(!this.timearrstring.length) {
              return defaultString
            } else {
              return this.timearrstring.replace(/1/g, '0').replace(/2/g, '1')
            }
        },
        //禁止选择的时间点，7*24的二维数组字符串，1表示不可选，0表示可选
        origin() {
           //默认值为全部可选，即7*24个0
           const defaultString = ('0'.repeat(24)+',').repeat(7).slice(0,-1)
           if(!this.timearrstring.length) {
              return defaultString
            } else {
              return this.timearrstring.replace(/2/g, '0')
            }
        },

        /**
         * 将用户给定的禁止选择时间点的字符串转换为int数组，若为空则初始化为7*24个0
         */
        sgArr(){
            if(!this.origin)  this.origin = ('0'.repeat(24)+',').repeat(7).slice(0,-1);
            return this.origin.split(',').map(s => (s.split('').map(f => +f)));
        },
        /**
         * 长度为7的一维bool数组，true表示该天所有时间点均被选中，false反之
         */
        isDayAllChecked(){
          return this.times.map(dayTimes =>
            //将选中的时间点叠加，得到每天选中的时间总数
            dayTimes.reduce((count, next) => count + next)
          ).map(total =>
            //是否能选的都选中了
            total == 24
          );
        },
        /**
         * 长度为24的一维int数组，7表示该时间点每天都被选中，小于7则表示未被全部选中
         */
        isHourAllChecked(){
            var temp   = new Array(24).fill(0),    //temp存储该时间点被选中的天数（包括被禁止的）
                sgSum = new Array(24).fill(0);  //sgSum存储该时间点被禁止选中的天数
            this.times.map((day, di) => {
                day.map((hour, hi) => {
                    temp[hi]  += hour;
                    sgSum[hi] += this.sgArr[di][hi];
                });
            });
            return temp.map((item, i) => item == 7 && sgSum[i] != 7);   //若被禁止的天数为7，则不选中改
        }
        
    },
    created(){
        /**
         * 将用户选择的时间点字符串转换为int数组
         */
        if(!this.timestring){
            this.initState = true;
            this.timestring = ('1'.repeat(24)+',').repeat(7).slice(0,-1);
        }
        this.parseTimeString();
        if(!this.times.length){
            this.$Modal.warn('选择时段组件初始化值不符合规范');
        }
        /**
         * 监控origin，若有修改则更新times数组
         */
        this.$watch('origin',function(){
            this.times = this.sgArr.map((day,dIndex) => {
                return day.map((hour, hIndex) => this.sgArr[dIndex][hIndex] ? 1 : this.times[dIndex][hIndex]);
            });
        });
        /**
         * 监控timestring，若有修改则更新times数组
         */
        this.$watch('timestring',function(){
            if(!this.timestring){
                return;
            }
            this.initState = false;
            this.parseTimeString();
        });
    },
    methods: {
        parseTimeString(){
            this.times = this.timestring.split(',').map((day,dIndex) => {
                return day.split('').map((hour, hIndex) => this.sgArr[dIndex][hIndex] ? 1 : +hour);
            });
        },
        /**
         * 时间点选择事件
         */
        selectTime(day, hour){
            this.times[day].splice(hour, 1, +!this.times[day][hour])
        },
        /**
         * 选择整天24小时
         */
        selectDay(day, bool){
            this.times[day].map((hour, hi) => this.times[day].splice(hi, 1, +bool));
        },
        /**
         * 选择整个时间点，7天全部选择
         */
        selectHour(hour){
            let checked = this.isHourAllChecked[hour] ? 0 : 1;
            this.times.map((day, di) => day.splice(hour, 1, checked))
        },
        /**
         * 选择指定的天数，全部、工作日、周末
         */
        selectSpecificDay(type){
            let selectDayMap = {
                all:     [1,1,1,1,1,1,1],
                weekday: [1,1,1,1,1,0,0],
                weekend: [0,0,0,0,0,1,1]
            };
            selectDayMap[type].forEach((s,i) => this.selectDay(i,s));
        },
        /**
         * 确定所选的时间点，触发父级注册的confirm事件
         */
        confirm(){
            this.initState = false;
            //更新时间数组，1为已投放，2为本次选择，0为未选择
            let newTimes = _.map(this.sgArr, (item,index) => {
              let newArr = []
              _.map(item, (arrItem, arrIndex) => {
                newArr.push(arrItem != 0 ? arrItem : this.times[index][arrIndex] == 0 ? 0 : 2)
              })
              return newArr
            })
            this.$emit('confirm', newTimes);
        },
        /**
         * 取消所勾选的时间
         */
        cancel(){
            this.parseTimeString();
            console.log('cancel')
            this.$emit('cancel', '');
        }
    }
}
</script>

<style scoped>
@import './timepicker.css'
</style>



// WEBPACK FOOTER //
// timepicker.vue?06e53f39